import { Injectable } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { QuestionBase } from "./question-base";

export interface FormOptions {
  disabled?: boolean;
  previousForm?: FormGroup;
}

@Injectable()
export class QuestionControlService {
  constructor() {}

  toFormGroup(questions: QuestionBase[], options?: FormOptions): FormGroup {
    const previousControls = options?.previousForm?.controls || {};
    const previousControlKeys = Object.keys(previousControls);
    const controls = questions.reduce((prev, curr) => {
      const key = curr.key;
      return previousControlKeys.includes(key) ? { ...prev, [key]: previousControls[key] } : { ...prev };
    }, {});

    const group: { [key: string]: AbstractControl } = { ...controls };
    questions.forEach((question) => {
      const { validated, errors, required, key, value, disabled } = question || {};

      if (!question || validated) {
        return;
      }
      const validators = errors.map<ValidatorFn>((v: { validator: ValidatorFn; message: string }) => v.validator);
      if (required) {
        validators.push(Validators.required);
      }
      group[key] = new FormControl(
        {
          value,
          disabled,
        },
        validators,
      );
      question.validated = true;
    });

    const formGroup = new FormGroup(group);
    if (options.disabled) {
      formGroup.disable();
    }
    if (options.previousForm?.dirty) {
      formGroup.markAsDirty();
    }
    return formGroup;
  }
}
